import { useState, useMemo, useEffect } from "react";
import { useLayout } from "../../../providers/LayoutProvider";

// components
import TalesHeader from "../components/TalesHeader";
import TalesFooter from "../components/TalesFooter";
import TaleCard from "../components/TaleCard";

import { parseIsoDate } from "../../../utils/dateUtils";
import { useTalesRepo } from "../db/useTalesRepo";

//icons
import { Search } from "lucide-react";

// Main TalesPage Component
const TalesPage = () => {
  const [searchQuery, setSearchQuery] = useState("");

  // use setters from LayoutProvider to set display and/or set header footer content
  const { setHeaderContent, setFooterContent } = useLayout();
  const { setShowHeader, setShowFooter } = useLayout();
  const talesRepo = useTalesRepo();
  const [tales, setTales] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // Add a loading state

  // set doc title
  useEffect(() => {
    document.title = "TOAT - My Tales";
  }, []);

  // Mount/unmount header + footer
  useEffect(() => {
    // hide header on this page
    setShowHeader(true);
    // show footer on this page
    setShowFooter(true);

    // Optionally set custom chrome instead:
    setHeaderContent(<TalesHeader />);
    setFooterContent(<TalesFooter />);

    // cleanup runs on unmount, and on dependency changes
    return () => {
      setShowHeader(true);
      setShowFooter(true);
      setHeaderContent(null);
      setFooterContent(null);
    };
  }, [setShowHeader, setShowFooter, setHeaderContent, setFooterContent]);

  // Load from JSON/DB
  useEffect(() => {
    // debug only
    // console.debug("Effect triggered", { taleId, segmentRepo });
    // if (!taleId) {
    //   console.debug("Waiting for taleId...");
    //   return;
    // }

    // if (!segmentRepo) {
    //   console.debug("Waiting for segmentRepo...");
    //   return;
    // }

    (async () => {
      const tales = await talesRepo.getAll();
      setTales(tales);
      setIsLoading(false); // Set loading to false after data is set
    })();
  }, []);

  // [ ] Load tales from db
  // const mockTrips = [
  //   {
  //     id: 1,
  //     name: "Florida 2025",
  //     startDate: "2025-10-25",
  //     endDate: "2025-11-01",
  //     year: 2025,
  //     image: "/images/florida.jpeg",
  //   },
  //   {
  //     id: 2,
  //     name: "Orcas Island",
  //     startDate: "2025-06-07",
  //     endDate: "2025-06-16",
  //     year: 2025,
  //     image: "/images/orcas.jpeg",
  //   },
  //   {
  //     id: 3,
  //     name: "Cozumel Mexico",
  //     startDate: "2022-11-26",
  //     endDate: "2022-12-03",
  //     year: 2022,
  //     image: "",
  //   },
  //   {
  //     id: 4,
  //     name: "Costa Rica",
  //     startDate: "2022-04-16",
  //     endDate: "2022-04-30",
  //     year: 2022,
  //     image: "/images/tamarindo.jpeg",
  //   },
  //   {
  //     id: 5,
  //     name: "Hawaiian Vacation",
  //     startDate: "2020-12-20",
  //     endDate: "2020-12-27",
  //     year: 2020,
  //     image: "/images/hawaii.jpeg",
  //   },
  // ];

  // Filter and group trips
  const filteredAndGroupedTales = useMemo(() => {
    const filtered = tales.filter((tale) =>
      tale.title.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const grouped = filtered.reduce((acc, tale) => {
      if (!acc[parseIsoDate(tale.startDateTime).year]) {
        acc[parseIsoDate(tale.startDateTime).year] = [];
      }
      acc[parseIsoDate(tale.startDateTime).year].push(tale);
      return acc;
    }, {});

    return Object.entries(grouped).sort((a, b) => b[0] - a[0]);
  }, [searchQuery, tales]);

  const handleTaleClick = (tale) => {
    alert("Tale clicked:", tale);
    console.log("Tale clicked:", tale);
    // Add your navigation or modal logic here
  };

  // if (isLoading) {
  //   return <p>Loading tales...</p>;
  // }

  return (
    <>
      <div className="tale-list">
        {/* Search Bar */}
        <div className="tale-search">
          <div className="tale-search-input">
            <Search
              size={20}
              style={{ color: "var(--text-muted)", marginRight: "12px" }}
            />
            <input
              type="text"
              placeholder="Search tales..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        {isLoading ? (
          <p>Loading tales...</p>
        ) : filteredAndGroupedTales.length === 0 ? ( // Nested ternary operator
          <div className="tales-by-year">
            <p>No tales found matching "{searchQuery}"</p>
          </div>
        ) : (
          filteredAndGroupedTales.map(([year, tales]) => (
            <div key={year} className="tale-year">
              <h1>{year}</h1>

              <div className="tales-this-year">
                {tales.map((tale) => (
                  <TaleCard
                    key={tale.id}
                    tale={tale}
                    onClick={() => handleTaleClick}
                  />
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default TalesPage;
